// Code/src/Components/ProfileVideos.tsx
import React, { useEffect, useCallback } from "react";
import { PrimaryButton, Stack } from "@fluentui/react";
import { Icon } from "@iconify-icon/react";
import { getProfileVideos } from "../Service/Services";

type ProfileVideosProps = {
  staff: any;
};

type ProfileVideo = {
  Id: number;
  Url: string;
  StaffLogin: string;
  ApplicantId: string;
  VideoType: string;
  VideoOrder: number;
  QuestionId: string;
  List: string;
};

const ProfileVideos = (props: ProfileVideosProps) => {
  const [profileVideos, setProfileVideos] = React.useState<ProfileVideo[]>([]);
  const handleRecordClick = () => {
    window.open(
      `https://interview.teampbs.com/user-questions?encryptedUserID=${props.staff?.EncryptedContractorGUID}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const staffNTName = props.staff?.NTName;

  const fetchProfileVideos = useCallback(async () => {
    try {
      const response = await getProfileVideos(staffNTName);
      setProfileVideos(response.data.value);
    } catch (error) {
      console.error("Error fetching profile videos:", error);
    }
  }, [staffNTName]);

  useEffect(() => {
    fetchProfileVideos();
  }, [fetchProfileVideos]);

  const skillsVideos = [...profileVideos]
    .filter((video) => video.VideoType === "Skills")
    .sort((a, b) => a.VideoOrder - b.VideoOrder);

  const experienceVideos = [...profileVideos]
    .filter((video) => video.VideoType === "Experience")
    .sort((a, b) => a.VideoOrder - b.VideoOrder);

  return (
    <div className="editProfile-container">
      <div className="contentContainer">
        <div className="content">
          <h2 className="title">
            <Icon className="cardIcon" icon="mdi:video" />
            Profile Videos
          </h2>
          <div className="contentCard">
            <div className="profileVideos-content">
              <Stack
                horizontal
                tokens={{ childrenGap: 12 }}
                className="profileVideos-buttonRow"
              >
                <PrimaryButton
                  text="Record Profile Video"
                  iconProps={{ iconName: "MSNVideosSolid" }}
                  onClick={handleRecordClick}
                  className="profileVideos-recordButton"
                />
              </Stack>

              <Stack
                horizontal
                wrap
                tokens={{ childrenGap: 24 }}
                className="profileVideos-videosRow"
              >
                <div className="profileVideos-videoSection">
                  <h3 className="sectionTitle">
                    Skills and Personal Qualities
                  </h3>
                  {skillsVideos.length === 0 ? (
                    <span style={{ color: `hsl(var(--foreground))` }}>
                      No skills videos available.
                    </span>
                  ) : (
                    skillsVideos.map((video) => (
                      <div
                        style={{
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          background: "hsl(var(--foreground))",
                          marginBottom: "15px",
                          borderRadius: "8px",
                        }}
                      >
                        <video
                          height={"350px"}
                          width={"100%"}
                          key={video.Id}
                          controls
                        >
                          <source src={video.Url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    ))
                  )}
                </div>

                <div className="profileVideos-videoSection">
                  <h3 className="sectionTitle">Experience</h3>

                  {experienceVideos.length === 0 ? (
                    <span style={{ color: `hsl(var(--foreground))` }}>
                      No experience videos available.
                    </span>
                  ) : (
                    experienceVideos.map((video) => (
                      <div
                        style={{
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          background: "#000",
                          marginBottom: "15px",
                          borderRadius: "8px",
                        }}
                      >
                        <video
                          height={"350px"}
                          width={"100%"}
                          key={video.Id}
                          controls
                        >
                          <source src={video.Url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    ))
                  )}
                </div>
              </Stack>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileVideos;
